const Winners = ({ winners = {}, setWinners }) => {
  const handleWinnerInput = (key, value) => {
    // If the field is cleared, remove the key so the input shows empty
    if (value === "") {
      setWinners((prev) => {
        const next = { ...prev };
        delete next[key]; // or: next[key] = undefined;
        return next;
      });
      return;
    }

    // Otherwise, store a number (fallback to 0 if parse fails)
    const n = parseInt(value, 10);
    setWinners((prev) => ({ ...prev, [key]: Number.isFinite(n) ? n : 0 }));
  };

  const winnerFields = [
    { key: "international", label: "International" },
    { key: "national", label: "National" },
    { key: "state", label: "State" },
    { key: "city", label: "City" },
    { key: "pincode", label: "Pincode" },
  ];

  return (
    <div className="mb-6 bg-blue-50 p-5 rounded-md border shadow-lg">
      <h3 className="text-lg font-semibold mb-4">
        Number of Winners to be Declared Based on Location
      </h3>

      {winnerFields.map(({ key, label }) => (
        <div key={key} className="mb-4">
          <label className="block font-medium capitalize">{label}:</label>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={winners[key] ?? ""}
            onChange={(e) => handleWinnerInput(key, e.target.value.replace(/[^0-9]/g, ""))}
            onKeyDown={(e) => {
              if (!/^\d$/.test(e.key) && !["Backspace","Delete","ArrowLeft","ArrowRight","Tab","Enter","Home","End"].includes(e.key) && !e.ctrlKey && !e.metaKey) e.preventDefault();
            }}
            onBlur={(e) => {
              if (e.target.value === "") setWinners((prev) => ({ ...prev, [key]: 0 }));
            }}
            className="border px-3 py-2 rounded-md w-full lg:w-1/2"
            placeholder={`Enter ${label} winners`}
          />
        </div>
      ))}
    </div>
  );
};

export default Winners;
